module.exports = __webpack_public_path__ + "img/chinabank.71a48d91.jpg";